import * as React from "react";
import { getPrePacksPrefix } from "../../components";
import { handleTeamLogoImageLoad, handleTeamLogoImageError, EVENT_TITLE_LOGO_SIZE } from "../helpers";
const baseClassName = getPrePacksPrefix("event");
const EventNames = React.memo(function EventNames(props) {
    const { teamOne, teamTwo, middleTerm } = props.name;
    return (React.createElement("div", { className: `${baseClassName}-name-wrapper`, "data-testid": "prepacks-event-name" },
        React.createElement("p", { className: `${baseClassName}-team-name` }, teamOne.name),
        React.createElement("span", { className: `${baseClassName}-separator` }, middleTerm),
        React.createElement("p", { className: `${baseClassName}-team-name` }, teamTwo.name)));
});
const EventLogoAndNames = React.memo(function EventLogoAndNames(props) {
    const { teamOne, teamTwo, middleTerm } = props.name;
    // Using null for useRef is a better practice than using undefined
    // eslint-disable-next-line no-null/no-null
    const team1IconRef = React.useRef(null);
    // eslint-disable-next-line no-null/no-null
    const team2IconRef = React.useRef(null);
    return (React.createElement("div", { className: `${baseClassName}-name-wrapper`, "data-testid": "prepacks-event-name" },
        React.createElement("div", { className: `${baseClassName}-team-wrapper` },
            teamOne.logo &&
                React.createElement("img", { ref: team1IconRef, src: teamOne.logo, className: `${baseClassName}-team-logo`, "data-testid": "prepacks-event-team-logo", alt: `${teamOne.name} logo`, width: EVENT_TITLE_LOGO_SIZE.width, height: EVENT_TITLE_LOGO_SIZE.height, 
                    // Using an arrow function here so we are able to pass the icon ref to the handler.
                    // eslint-disable-next-line react/jsx-no-bind
                    onError: () => handleTeamLogoImageError(team1IconRef), 
                    // eslint-disable-next-line react/jsx-no-bind
                    onLoad: () => handleTeamLogoImageLoad(team1IconRef), loading: "lazy" }),
            React.createElement("p", { className: `${baseClassName}-team-name` }, teamOne.name)),
        React.createElement("span", { className: `${baseClassName}-separator` }, middleTerm),
        React.createElement("div", { className: `${baseClassName}-team-wrapper` },
            React.createElement("p", { className: `${baseClassName}-team-name` }, teamTwo.name),
            teamTwo.logo &&
                React.createElement("img", { ref: team2IconRef, src: teamTwo.logo, className: `${baseClassName}-team-logo`, "data-testid": "prepacks-event-team-logo", alt: `${teamTwo.name} logo`, width: EVENT_TITLE_LOGO_SIZE.width, height: EVENT_TITLE_LOGO_SIZE.height, 
                    // Using an arrow function here so we are able to pass the icon ref to the handler.
                    // eslint-disable-next-line react/jsx-no-bind
                    onError: () => handleTeamLogoImageError(team2IconRef), 
                    // eslint-disable-next-line react/jsx-no-bind
                    onLoad: () => handleTeamLogoImageLoad(team2IconRef), loading: "lazy" }))));
});
const EventNameMap = {
    Name(props) { return React.createElement(EventNames, Object.assign({}, props)); },
    LogoAndNames(props) { return React.createElement(EventLogoAndNames, Object.assign({}, props)); },
};
export function EventName({ type, props }) {
    return EventNameMap[type](props);
}
//# sourceMappingURL=EventName.js.map